export const PIPELINE_STEPS = [
    "scan", "classify", "key", "verify", "qa", "qc", "supervisor", "export",
];
/** The queues-feature step list (dropdowns) — membership frozen (no "qc"). */
export const STEP_OPTIONS = [
    "scan", "classify", "key", "verify", "qa", "supervisor", "export",
];
/** Steps classified as QC-lane for queue feeds — frozen. */
export const QC_STEPS = ["qc", "qa", "supervisor"];
export const STEP_LABELS = {
    scan: "Scan", classify: "Classify", key: "Key Entry", verify: "Verify",
    qa: "QA", qc: "QC", supervisor: "Supervisor", export: "Export",
};
/**
 * F-036 — bridge from the pipeline-step vocabulary carried on documents
 * (`doc.currentStep`: 'key' | 'verify' | 'qc' | 'supervisor' …) to the Stage
 * vocabulary rules are authored against. Accepts both 'qa' and 'qc' (the
 * pipeline stepType word — F-039 lesson). Unknown steps fall back to
 * 'verification', preserving the station's legacy behavior for exotic steps.
 * Moved verbatim from form-config/behaviors.ts — mapping frozen.
 */
export function stageForStep(step) {
    switch (step) {
        case 'key': return 'key-entry';
        case 'verify': return 'verification';
        case 'qa':
        case 'qc': return 'qa';
        case 'supervisor': return 'supervisor';
        default: return 'verification';
    }
}
/**
 * Steps that carry an EXPLICIT stageForStep mapping (not the 'verification'
 * default-fallback). stepsForStage inverts over these only — otherwise
 * scan/classify/export (which fall through to 'verification') would be
 * reported as verification-stage steps, and `stepsForStage('verification')`
 * would read as ['scan','classify','verify','export'] instead of ['verify'].
 */
const EXPLICIT_STAGE_STEPS = ["key", "verify", "qa", "qc", "supervisor"];
export function stepsForStage(stage) {
    return EXPLICIT_STAGE_STEPS.filter((s) => stageForStep(s) === stage);
}
/**
 * R1 (E-062 / F-054) — `stageForStep` WITHOUT the 'verification' fallback:
 * only the explicitly-mapped edit-capable steps resolve; scan/classify/export
 * (and unknown step words) yield null. The workflow engine uses this to filter
 * step-scoped action rules — a rule scoped to `stages: ['verification']` must
 * not fire when a document enters scan/classify/export merely because those
 * words default to 'verification' in the station-legacy mapping.
 */
export function explicitStageForStep(step) {
    return EXPLICIT_STAGE_STEPS.includes(step) ? stageForStep(step) : null;
}
//# sourceMappingURL=step-stage.js.map